
import React, { useEffect, useState } from 'react';
import './Sidebar.scss';
import { useDispatch, useSelector } from 'react-redux';
import { setloggedIn } from '../../../store/Slices/userSlice.js';
import { SidebarData } from './sidebarData/SideabrData.jsx';
import { IBSidebarData } from './sidebarData/IBSidebarData.jsx';
import { useNavigate, useLocation } from 'react-router-dom';
import { Sidebar, Menu, SubMenu } from 'react-pro-sidebar';
import ConfirmationModal from '../../modals/ConfirmationModal.jsx';
import { LogoutApi, ClearNotificationApi, GetNotificationApi } from '../../../api/request/users.js';
import toast from 'react-hot-toast';
import { removeCookies } from '../../../services/Cookies.jsx';
import { Avatar, Badge, Drawer } from 'antd';
import Profile from '../../../pages/user/profile/Profile.jsx';
import Notifications from '../notifications/Notifications.jsx';
import Bellicon from '../../../assets/Bellicon.jsx';
import * as signalR from '@microsoft/signalr';
import { Cookies } from "react-cookie";
import { IpProvider } from '../../../services/IpProvider.js';

export default function AppSidebar({ ib }) {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const cookies = new Cookies();
    const { token } = cookies.getAll();
    const [isKycCompleted, setIsKycCompleted] = useState(false);
    const { userDetails } = useSelector(state => state.user);
    const { pathname } = useLocation();
    const [isLoading, setIsLoading] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [isNotification, setIsNotification] = useState(false);
    const [notifications, setNotifications] = useState({ isReadCount: 0, unReadCount: 0, totalMessageCount: 0, details: [] });
    const [openSubMenuIndex, setOpenSubMenuIndex] = useState(null);
    const [isfetchNotification, setIsFetchNotification] = useState(false);
    const [connection, setConnection] = useState("");
    const [ipAddress, setIpAddress] = useState('');

    const filteredSidebarData = () => {
        return (ib ? IBSidebarData : SidebarData).filter(item => {
            if (item.title === 'Perent Tree' && !userDetails?.isShowParentTree) {
                return false;
            }
            return true;
        });
    };

    const initializeSignalRConnection = () => {
        try {
            if (!connection) {
                const newConnection = new signalR.HubConnectionBuilder()
                    .withUrl("https://backend.rimglobal.trade/chathub", { accessTokenFactory: () => token })
                    .withAutomaticReconnect()
                    .build()
                setConnection(newConnection);

            } else {
            }
        } catch (error) { toast.error(error.message) }
    }

    useEffect(() => {
        if (isfetchNotification) {
            initializeSignalRConnection();
        }
    }, [isfetchNotification]);

    useEffect(() => {
        if (connection) {
            connection.start()
                .then(() => { })
                .catch(err => { })
            // const data = await connection.start();
            connection.on("ReceiveMessage", (data) => {
                setNotifications(prevState => ({
                    ...prevState,
                    isReadCount: prevState.isReadCount,
                    unReadCount: prevState.unReadCount + 1,
                    totalMessageCount: prevState.totalMessageCount + 1,
                    details: prevState?.details?.length ? [...prevState?.details, data] : [data]
                }));
            });
            connection.onclose((error) => {
            })
        }
    }, [connection]);

    const getNotification = async () => {
        try {
            const { data } = await GetNotificationApi();
            if (data?.success) {
                setNotifications(data?.data);
            }
            setIsFetchNotification(true);
        } catch (error) { setIsFetchNotification(true); }
    }

    const handleMenuClick = (index) => { setOpenSubMenuIndex(index); };

    const getIpAddress = async () => {
        try {
            const { data } = await IpProvider();
            setIpAddress(data?.ip);
        } catch (error) { }
    }

    useEffect(() => {
        if (userDetails?.kycStatus === 'Approved') {
            setIsKycCompleted(true);
        };
        getNotification();
        getIpAddress();
    }, []);

    const getFirstPath = (path) => {
        const parts = path.split('/');
        if (ib) {
            return parts.length > 1 ? '/' + parts[1] + '/' + parts[2] : path;
        } else {
            return parts.length > 1 ? '/' + parts[1] : path;
        }
    }

    const isActivePath = (path) => {
        let active = false;
        path?.map((item) => {
            if (item == (getFirstPath(pathname))) {
                active = true;
            }
        })
        return active;
    }

    const logoutHandler = async () => {
        try {
            setIsLoading(true);
            const { data } = await LogoutApi({ ipAddress });
            if (data?.success) {
                toast.success(data?.message);
            }
            localStorage.clear();
            dispatch(setloggedIn(false));
            removeCookies('token');
            navigate('/');
            setIsModalOpen(false);
            setIsLoading(false);
        } catch (err) {
            dispatch(setloggedIn(false));
            removeCookies('token');
            navigate('/');
            setIsModalOpen(false);
            setIsLoading(false);
        }
    }

    const clearNotifications = async () => {
        const { data } = await ClearNotificationApi();
        if (data.success) {
            setNotifications({ isReadCount: 0, unReadCount: 0, totalMessageCount: 0, details: [] });
            toast.success(data.message);
        }
    };

    useEffect(() => {
        
    }, [notifications]);

    return (
        <div className='sidebar-container w-[250px] pt-1 fixed'>
            <div className='px-4'>
                <div className='flex justify-between items-center py-3'>
                    <img className='h-[44px]' src='/assets/logo/logo.png' alt='logo' />
                    <div className='cursor-pointer' onClick={() => setIsNotification(true)}>
                        <Badge count={notifications?.unReadCount || 0} overflowCount={5}>
                            <Bellicon />
                        </Badge>
                    </div>
                </div>
            </div>

            <hr className='border-[#8D5AE226] pb-2' />

            <div className='h-[calc(100vh-172px)] overflow-y-auto pl-4'>

                {
                    filteredSidebarData().map((item, index) => {
                        const iconWithProps = item?.icon ? React.cloneElement(item?.icon, { active: isActivePath(item?.activeUrl) }) : null;
                        return (
                            item?.child ? (
                                <Sidebar key={index}>
                                    <Menu>
                                        <SubMenu key={index} open={openSubMenuIndex === index} onOpenChange={() => handleMenuClick(index === openSubMenuIndex ? null : index)}
                                            // disabled={(!isKycCompleted && item?.kycApproval)} 
                                            label={
                                                <button key={index} className={`flex items-center sidebarColor font-medium cursor-pointer py-2 px-4 header`}>
                                                    {iconWithProps}
                                                    <p className='text-base ms-3'>{item?.title}</p>
                                                </button>
                                            }>
                                            <div className='pt-1'>
                                                {
                                                    item?.child?.map((childItem, childIndex) => {
                                                        const childIconWithProps = childItem?.icon ? React.cloneElement(childItem?.icon, { active: isActivePath(childItem?.activeUrl) }) : null;
                                                        return (
                                                            <div key={childIndex} onClick={() => navigate(childItem?.url)} className={`submenu child flex items-center sidebarColor cursor-pointer font-medium py-2 ms-5 ps-4 pe-6 mr-4 duration-200 ${index != 0 ? 'mt-1' : null} ${isActivePath(childItem?.activeUrl) ? 'active_icon primary text-white rounded-lg font-semibold' : null}`}>
                                                                {childIconWithProps}
                                                                <p className='text-base ms-3'>{childItem?.title}</p>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </SubMenu>
                                    </Menu>
                                </Sidebar>
                            ) : (
                                <div key={index} onClick={() => navigate(item?.url)} className={`${(isKycCompleted && item?.unAuth) ? 'hidden' : ''}  font-medium rounded-lg cursor-pointer hover:bg-hover my-3 mr-4 duration-200 ${isActivePath(item?.activeUrl) ? 'shadow-inner bg-gradient text-white  font-semibold' : 'sidebarColor'}`}>
                                    <button
                                        // disabled={(!isKycCompleted && item?.kycApproval)} 
                                        onClick={() => handleMenuClick(index)} className='flex items-center w-full py-2 px-4'>
                                        {iconWithProps}
                                        <p className='text-base ms-3'>{item?.title}</p>
                                    </button>
                                </div>
                            )
                        )
                    })
                }
            </div>

            <div className='px-4 mt-6'>
                <div className='flex items-center justify-between cursor-pointer mb-2' >
                    <div className='flex items-center' onClick={() => navigate('/profile')}>
                        <Avatar size={46} className="uppercase bg-primary" src={userDetails?.profileImage}>{userDetails?.firstName?.charAt(0)}{userDetails?.lastName?.charAt(0)}</Avatar>
                        <div className='ml-2'>
                            <p className='font-semibold text-base line-clamp-1 capitalize'>{userDetails?.fullName}</p>
                            <p className='text-sm primary'>{userDetails?.roleName} Account</p>
                        </div>
                    </div>
                    <button className='text-sm text-red-600 font-semibold px-4 py-2 flex items-center gap-3' onClick={() => setIsModalOpen(true)}>
                        <img src='/assets/icons/logout.svg' className='h-5' alt='icon' />
                        {/* <p>Logout</p> */}
                    </button>
                </div>
            </div>

            {/* --- Logout confirmation modal --- */}
            <ConfirmationModal
                isOpen={isModalOpen}
                setIsOpen={setIsModalOpen}
                message='Are you sure you want to logout?'
                onConfirm={logoutHandler}
                isLoading={isLoading}
                loadingLabel='Logging out...'
            />

            {/* --- User profile drawer --- */}
            <Drawer title={
                <div className='flex justify-between items-center'>
                    <p>Profile</p>
                    <button className='text-sm text-red-600 font-semibold px-4 py-2 flex items-center gap-3' onClick={() => setIsModalOpen(true)}>
                        <img src='/assets/icons/logout.svg' className='h-5' alt='icon' />
                        <p>Logout</p>
                    </button>
                </div>
            } onClose={() => setIsDrawerOpen(false)} width={600} open={isDrawerOpen}>
                <Profile isDrawer={isDrawerOpen} />
            </Drawer>

            {/* --- Notification drawer --- */}
            <Drawer
                title={
                    <div className="flex justify-between items-center">
                        <p>Notification</p>
                        <p className='cursor-pointer' onClick={clearNotifications}>Clear all</p>
                    </div>
                }
                onClose={() => setIsNotification(false)}
                width={600}
                open={isNotification}
            >
                <Notifications notifications={notifications} getNotification={getNotification} />
            </Drawer>
        </div>
    )
}
